import React from 'react';

// import { IconButton, makeStyles, Theme } from '@material-ui/core';
// import Check from '@material-ui/icons/Check';
// import Close from '@material-ui/icons/Close';
import { IWithActionButtonProps } from '../../prop-types';
import IconButton from './IconButton';
import Check from '../svg/Check';
import Cancel from '../svg/Cancel';

interface IConfirmationIconsProps extends IWithActionButtonProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmationIcons({
  onConfirm,
  onCancel,
  ...props
}: IConfirmationIconsProps) {
  return (
    <>
    <IconButton {...props.editButton} onClick={onConfirm}>
      <Check />
    </IconButton>
    <IconButton {...props.deleteButton} onClick={onCancel}>
      <Cancel />
    </IconButton>
    </>
  );
}
